import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CLIENT_ROUTES } from "../../config/routes";
import { selectIsUserLoggedIn } from "../../pages/auth/LoginAuthSlice";

function RequireAuth({ navigateTo = CLIENT_ROUTES.CLIENT_LOGIN }) {
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn)
  let location = useLocation();

  if (!isUserLoggedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={navigateTo} state={{ from: location }} />;
  }

  return <Outlet />;
}

export default RequireAuth;